import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";

const ImageUpload = ({ onImagesChange }) => {
  const [images, setImages] = useState([]);
  const [uploadLimitReached, setUploadLimitReached] = useState(false);

  const onDrop = useCallback(
    (acceptedFiles) => {
      if (images.length + acceptedFiles.length > 10) {
        setUploadLimitReached(true);
        return;
      } else {
        setUploadLimitReached(false);
      }

      const newImages = acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) }),
      );

      setImages((prevImages) => {
        const updatedImages = [...prevImages, ...newImages];
        onImagesChange(updatedImages);
        return updatedImages;
      });
    },
    [images, onImagesChange],
  );

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpeg", ".jpg"],
    },
    onDrop,
    multiple: true,
  });

  const handleDelete = (file) => {
    const updatedImages = images.filter((img) => img !== file);
    setImages(updatedImages);
    onImagesChange(updatedImages);
    setUploadLimitReached(false);
  };

  return (
    <div>
      <div {...getRootProps()} style={dropzoneStyles}>
        <input {...getInputProps()} />
        <p>Drag & drop images here, or click to select images</p>
      </div>

      {images.length > 0 && (
        <div style={previewContainerStyles}>
          {images.map((file, index) => (
            <div key={file.preview + index} style={{ position: "relative" }}>
              <img src={file.preview} alt={file.name} style={imageStyles} />
              <button
                onClick={() => handleDelete(file)}
                style={deleteButtonStyles}
              >
                X
              </button>
            </div>
          ))}
        </div>
      )}

      {uploadLimitReached && (
        <p style={info}>Max upload limit reached. (10 images)</p>
      )}
    </div>
  );
};

const dropzoneStyles = {
  border: "2px dashed #cccccc",
  borderRadius: "4px",
  padding: "20px",
  textAlign: "center",
  cursor: "pointer",
};

const previewContainerStyles = {
  display: "flex",
  marginTop: "20px",
  flexWrap: "wrap",
  gap: "10px",
};

const imageStyles = {
  width: "100px",
  height: "100px",
  objectFit: "cover",
  borderRadius: "4px",
};

const deleteButtonStyles = {
  position: "absolute",
  top: "-5px",
  right: "-5px",
  background: "red",
  color: "white",
  border: "none",
  borderRadius: "50%",
  width: "20px",
  height: "20px",
  cursor: "pointer",
};

const info = {
  color: "red",
  marginTop: "10px",
};

export default ImageUpload;
